export default __webpack_public_path__ + "static/media/IMG-20220120-WA0010.9d4a42ef.png";